<template>
    <Modal
        wrapper-class="animate__animated"
        :in-class="`animate__bounceIn`"
        :out-class="`animate__bounceOut`"
        bg-class="animate__animated"
        :bg-in-class="`animate__bounceIn`"
        :bg-out-class="`animate__bounceOut`"
        v-model="verModalDocumentos"
        :title="'Vista previa del documento'"
        :modal-style="modalStyles"
        :enableClose="false"
        @before-open="beforeOpen" @before-close="beforeClose"
        @close="cerrarModal">
        
        <span v-if="$mq === 'mobile'">
            <CRow>
                <CCol>
                    <CSwitch
                        width="150px"
                        class="mt-1 mx-1 align-middle mb-2 switchGesto"
                        shape="pill"
                        variant="outline"
                        v-bind="{labelOn: 'Si',labelOff: 'No'}"
                        :checked="selectPdf"
                        @update:checked="cambiotipoDoc('pdf')"
                    /> <span style="padding-top: 9px">Generar PDF</span>
                </CCol>
                <CCol>
                    <CSwitch
                        width="150px"
                        class="mt-1 mx-1 align-middle mb-2 switchGesto"
                        shape="pill"
                        variant="outline"
                        v-bind="{labelOn: 'Si',labelOff: 'No'}"
                        :checked="selectCsv"
                        @update:checked="cambiotipoDoc('csv')"
                    /> <span style="padding-top: 9px">Generar CSV</span>
                </CCol>
            </CRow>
            <hr v-show="selectPdf">
            <CRow v-show="selectPdf">
                <CCol>
                    <span>
                        <CSwitch
                            width="150px"
                            class="mt-1 mx-1 align-middle mb-2 switchGesto"
                            shape="pill"
                            variant="outline"
                            v-bind="{labelOn: 'Si',labelOff: 'No'}"
                            :checked="generarConFirmas"
                            @update:checked="generarConFirmas = !generarConFirmas"
                        /> <span style="padding-top: 9px">Generar con firmas</span>

                    </span>
                    
                    <span>
                        <CSwitch
                            width="150px"
                            class="mt-1 mx-1 align-middle mb-2 switchGesto"
                            shape="pill"
                            variant="outline"
                            v-bind="{labelOn: 'Si',labelOff: 'No'}"
                            :checked="generarConArt100"
                            @update:checked="generarConArt100 = !generarConArt100"
                        /> <span style="padding-top: 9px">Generar con Art. 100</span>
                    </span>
                </CCol>
                
            </CRow>
            <CRow>
                <CCol v-show="selectPdf || selectCsv">
                    <CButton
                        size="sm"
                        v-show="selectPdf || selectCsv"
                        variant="ghost"
                        class="btnPrincipalVapp mb-1 ml-1 mr-1 float-left"
                        @click="generarDocumento"
                        :disabled="isLoadingDocumento">
                            <CIcon v-show="isLoadingDocumento" :content="$options.freeSet.cilLoopCircular" class="imgr" />
                            Generar Documento
                    </CButton>
                </CCol>
                <CCol>
                    <CButton
                        v-show="documentoGenerado"
                        style="width: 100%;"
                        size="sm"
                        variant="ghost"
                        class="btnPrincipalVapp mb-1 mr-1"
                        @click="descargarDocumento"
                        :disabled="isLoadingDocumento"
                        v-c-tooltip.hover="{content: 'Descargar Documento generado',placement: 'rigth'}">
                            <CIcon size="sm" :content="$options.freeSet.cilCloudDownload" />
                            Descargar Documento
                    </CButton>
                </CCol>
                
            </CRow>
            <CRow>
                <CCol>
                    <CargandoInfo class="center-content" :mostrarCarga="isLoadingDocumento" :mensajeInfo="'Generando...'" />
                    
                    <iframe
                        v-show="!isLoadingDocumento && documentoGenerado"
                        :src="limpiarURL(docSeleccionado.linkView)"
                        width="100%"
                        height="400"
                        allow="autoplay "
                    ></iframe>
                </CCol>
            </CRow>
        </span>
        
        <span v-else>
            <CRow>
                <CCol :col="isLoadingDocumento || documentoGenerado? 3 : 11">
                    <CRow>
                        <CCol :col="isLoadingDocumento || documentoGenerado? 12 : 6">
                            <CRow>
                                <CCol>
                                    <CSwitch
                                        width="150px"
                                        class="mt-1 mx-1 align-middle mb-2 mr-1 switchGesto"
                                        shape="pill"
                                        variant="outline"
                                        v-bind="{labelOn: 'Si',labelOff: 'No'}"
                                        :checked="selectPdf"
                                        @update:checked="cambiotipoDoc('pdf')"
                                    /> <span style="padding-top: 9px"><i class="pi pi-file-pdf" style="font-size: 1.1rem;" /> Generar PDF</span>
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol>
                                    <CSwitch
                                        width="150px"
                                        class="mt-1 mx-1 align-middle mb-2 mr-1 switchGesto"
                                        shape="pill"
                                        variant="outline"
                                        v-bind="{labelOn: 'Si',labelOff: 'No'}"
                                        :checked="selectCsv"
                                        @update:checked="cambiotipoDoc('csv')"
                                    /> <span style="padding-top: 9px"> <i class="pi pi-file-excel" style="font-size: 1.1rem;" />Generar CSV</span>
                                </CCol>
                            </CRow>
                        </CCol>
                        <CCol :col="isLoadingDocumento || documentoGenerado? 12 : 6">
                            
                            <hr v-show="selectPdf && (isLoadingDocumento || documentoGenerado)">
                            <CRow v-show="selectPdf">
                                <CCol>
                                    <CSwitch
                                        width="150px"
                                        class="mt-1 mx-1 align-middle mb-2 mr-1 switchGesto"
                                        shape="pill"
                                        variant="outline"
                                        v-bind="{labelOn: 'Si',labelOff: 'No'}"
                                        :checked="generarConFirmas"
                                        @update:checked="generarConFirmas = !generarConFirmas"
                                    /> <span style="padding-top: 9px">Generar con firmas</span>
                                </CCol>
                            </CRow>
                            <CRow v-show="selectPdf">
                                
                                <CCol>
                                    <CSwitch
                                        width="150px"
                                        class="mt-1 mx-1 align-middle mb-2 mr-1 switchGesto"
                                        shape="pill"
                                        variant="outline"
                                        v-bind="{labelOn: 'Si',labelOff: 'No'}"
                                        :checked="generarConArt100"
                                        @update:checked="generarConArt100 = !generarConArt100"
                                    /> <span style="padding-top: 9px">Generar con Art. 100</span>
                                </CCol>
                            </CRow>
                        </CCol>
                    </CRow>
                    
                    <CRow>
                        <CCol v-show="selectPdf || selectCsv">
                            <CButton
                                size="sm"
                                v-show="selectPdf || selectCsv"
                                variant="ghost"
                                class="btnPrincipalVapp mb-1 ml-1 mr-1 float-left"
                                @click="generarDocumento"
                                :disabled="isLoadingDocumento">
                                    <!--<CIcon v-show="isLoadingDocumento" :content="$options.freeSet.cilLoopCircular" class="imgr" />-->
                                    <span  style="padding-top: 9px">
                                        <i v-show="selectCsv" class="pi pi-file-excel mr-1" style="font-size: 0.9rem;" :class="isLoadingDocumento ? 'imgr' : ''" />
                                        <i v-show="selectPdf" class="pi pi-file-pdf" style="font-size: 0.9rem;" :class="isLoadingDocumento ? 'imgr' : ''" />
                                        Generar Documento
                                    </span>
                                    
                            </CButton>
                        </CCol>
                        <CCol>
                            <CButton
                                v-show="documentoGenerado"
                                style="width: 100%;"
                                size="sm"
                                variant="ghost"
                                class="btnPrincipalVapp mb-1 mr-1"
                                @click="descargarDocumento"
                                :disabled="isLoadingDocumento"
                                v-c-tooltip.hover="{content: 'Descargar Documento generado',placement: 'rigth'}">
                                    <CIcon size="sm" :content="$options.freeSet.cilCloudDownload" />
                                    Descargar Documento
                            </CButton>
                        </CCol>
                        
                    </CRow>
                </CCol>  
                <CCol :col="isLoadingDocumento || documentoGenerado? 9 : 1">
                    <CargandoInfo class="center-content" :mostrarCarga="isLoadingDocumento" :mensajeInfo="'Generando...'" />
                   
                    <iframe
                    v-if="documentoGenerado"
                        v-show="!isLoadingDocumento && documentoGenerado"
                        :src="limpiarURL(docSeleccionado.linkView)"
                        width="100%"
                        height="400"
                        allow="autoplay "
                    ></iframe>
                </CCol>    
            </CRow>
        </span>

        <div class="modal-footer">
            <CButton
                class="btnPrincipalVapp"
                @click="cerrarModal">
                Salir
            </CButton>
        </div>
            
    </Modal>
</template>

<script>

    import VueModal from '@kouts/vue-modal';
    import '@kouts/vue-modal/dist/vue-modal.css';

    import { freeSet } from '@coreui/icons'

    
    import CargandoInfo from '@/views/utils/CargandoInfo'

    
    import bodyScroll from 'body-scroll-freezer'
    

    export default {
        name: 'ModalGeneracionDocumento',
        freeSet,
        props: {
            verModalDocumentos: Boolean,
            isLoadingDocumento: Boolean,
            documentoGenerado: Boolean,
            docSeleccionado: Object,
            isLoadingDocumento: Boolean,
        },
        components: {
            'Modal': VueModal,
            CargandoInfo
            
        },
        data () {
            return {
                
                generarConFirmas: false,
                generarConArt100: false,
                selectPdf: false,
                selectCsv: false,
                modalSize: false

            }
        },
        
        mounted(){
            bodyScroll.init()
        },
        computed: {
            modalStyles(){
                return this.$mq === 'mobile' ? { 'min-width' : '300px' , 'max-width' : '500px' } : (this.modalSize
                ? { 'min-width' : '800px' , 'max-width' : '1140px' }
                : { 'min-width' : '300px' , 'max-width' : '500px' })
            }
        },
        methods: {
            beforeOpen() {
                bodyScroll.freeze()
            },
            beforeClose() {
                bodyScroll.unfreeze()
            },
            cerrarModal: function () {
                if(this.documentoGenerado)
                    this.modalSize = true;
                //this.verDocumento = false;
                //this.verModalDocumentos = false;
                this.$emit('cerrarModal')
                
            },
            cambiotipoDoc: function(tipoDoc){
                if(tipoDoc === 'pdf'){
                    this.selectPdf = !this.selectPdf
                    if(this.selectPdf)
                        this.selectCsv = false;
                }else if(tipoDoc === 'csv'){
                    this.selectCsv = !this.selectCsv;
                    if(this.selectCsv)
                        this.selectPdf = false;
                }
            },
            limpiarURL: function(url) {
                let urlObj = new URL(url);
                let pathParts = urlObj.pathname.split('/');
                
                if (url.includes("docs.google.com/spreadsheets")) {
                    // 📄 Google Sheets
                    let idIndex = pathParts.indexOf("d") + 1;
                    if (idIndex > 0 && idIndex < pathParts.length) {
                        let id = pathParts[idIndex];
                        console.log("`https://docs.google.com/spreadsheets/d/${id}/pubhtml`", `https://docs.google.com/spreadsheets/d/${id}/edit?embedded=true`)
                        return `https://docs.google.com/spreadsheets/d/${id}/edit?embedded=true`;
                    }
                } else if (url.includes("drive.google.com/file")) {
                    // 📁 Google Drive (PDFs, imágenes, Word, etc.)
                    let idIndex = pathParts.indexOf("d") + 1;
                    if (idIndex > 0 && idIndex < pathParts.length) {
                        let id = pathParts[idIndex];
                        return `https://drive.google.com/file/d/${id}/preview`;
                    }
                }
                return url; // Devuelve la URL original si hay error
            },

            generarDocumento: function(){
                
                this.modalSize = true
                let opciones = {
                    pdf: this.selectPdf,
                    csv: this.selectCsv,
                    firmas: this.generarConFirmas,
                    art100: this.generarConArt100
                }
                this.$emit('generarDocumento', opciones)  
            },
            descargarDocumento: function(){
                /*var doc = null
                if(tipo === 'pdf'){
                    doc = this.docPdf
                }
                else if(tipo === 'csv'){
                    doc = this.docCsv
                }*/
                var fileLink = document.createElement("a");
                fileLink.href = this.docSeleccionado.link;
                fileLink.setAttribute("download", this.docSeleccionado.nombre);
                document.body.appendChild(fileLink);
                fileLink.click();
            },
        }
    }
</script>

<style scoped>
    
    .switchGesto .c-switch-input:checked + .c-switch-slider {
        border-color: #29235C;
    }
    .switchGesto .c-switch-input:checked + .c-switch-slider::before {
        background-color: #29235C;
        border-color: #29235C;
    }
    .switchGesto .c-switch-input:checked + .c-switch-slider::after {
        color: #29235C;
    }
    .switchGesto .c-switch-slider {
        border-color: #29235C;
    }
    .switchGesto .c-switch-slider::before {
        background-color: #29235C;
        border-color: #29235C;
    }
    .switchGesto .c-switch-slider::after {
        color: #461A3B;

    }
</style>